"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _ShareInput = _interopRequireDefault(require("../../decorators/ShareInput"));

var _UISearchInput = _interopRequireDefault(require("../../input/UISearchInput"));

var _component = _interopRequireDefault(require("../../utils/propTypes/component"));

var UITypeaheadSearch = _react.default.createClass({
  displayName: "UITypeaheadSearch",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    'aria-controls': _react.PropTypes.string,
    Input: _component.default.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      Input: _UISearchInput.default
    };
  },
  render: function render() {
    var _this$props = this.props,
        ariaControls = _this$props['aria-controls'],
        className = _this$props.className,
        Input = _this$props.Input,
        style = _this$props.style,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["aria-controls", "className", "Input", "style"]);
    return _react.default.createElement("div", {
      className: (0, _classNames.default)('private-search-control__wrapper', className),
      style: style
    }, _react.default.createElement(Input, (0, _extends2.default)({
      "aria-autocomplete": "list",
      "aria-controls": ariaControls
    }, rest)));
  }
});

var _default = (0, _ShareInput.default)(UITypeaheadSearch);

exports.default = _default;
module.exports = exports.default;